
const initState = () => ({
})

export const state = initState

export const getters = {
}

export const mutations = {

}

export const actions = {


  async printDailyReport({}, {filters}) {
    try{
      const response = await this.$axios.post(`webpos/reports/print-daily-report`, filters, {responseType: 'blob'})
      if(response){
        const createdFile = new File(
          [response.data],
          "report.pdf" || 'report.pdf',
          {type: 'application/pdf'}
        )
        const url = window.URL.createObjectURL(createdFile)
        window.open(url, '_blank')
      }
      else{
        this.$toast.error('Error while printing report')
      }

    }
    catch{
      this.$toast.error('Error while printing report')
    }
  },


  async getReportVersionsDataByReportCode({}, reportCode){
    let reportVersions = []
    try{
      const result = await this.$axios.$get(`/webpos/reports/${reportCode}/report-version-data`)
      if (result.apiMessages?.hasErrors) {
        this.$toast.error('Error while getting report versions')
      }
      else{
        reportVersions = result.value;
      }
    }
    catch(ex){
      this.$toast.error('Error while getting report versions')
    }
    return reportVersions;
  },

  async printReportByReportVersionID({}, {reportVersionID, reportVersionFilter}){
    try {
      if (reportVersionID < 0) {
        this.$toast.error('The report version id is incorrect')
      }
      const response = await this.$axios.get(`webpos/reports/report-version/${reportVersionID}/print?${new URLSearchParams(reportVersionFilter).toString()}`, {responseType: 'blob'})
      if (response) {
        const createdFile = new File(
          [response.data],
          "report.pdf" || 'report.pdf',
          {type: 'application/pdf'}
        )
        const url = window.URL.createObjectURL(createdFile)
        window.open(url, '_blank')
      } else {
        this.$toast.error('Error while printing report')
      }
    }
    catch(ex){
      this.$toast.error('Error while printing report')
    }
  },

  async printReportWithSignatureByReportVersionID({}, {reportVersionFilter, signatureInformation, reportSignatureSaveToAttribute}){
    try {
      if (signatureInformation.relatedEntity.reportVersion.id < 0) {
        this.$toast.error('The report version id is incorrect')
        return;
      }

      const response = await this.$axios.get(`webpos/reports/report-version/${signatureInformation.relatedEntity.reportVersion.id}/print?${new URLSearchParams(reportVersionFilter).toString()}`, {responseType: 'blob'})

      if (response) {
        const createdFile = new File(
          [response.data],
          "report.pdf" || 'report.pdf',
          {type: 'application/pdf'}
        )

        await reportSignatureSaveToAttribute(signatureInformation.relatedEntity, signatureInformation.customAttributes, createdFile)

        const url = window.URL.createObjectURL(createdFile)
        window.open(url, '_blank')
      }
      else {
        this.$toast.error('Error while printing report')
      }
    }
    catch(ex){
      this.$toast.error('Error while printing report')
    }
  },


}
